<form [formGroup]="filtersForm">
    <div class="filters-analytics">
        <div>
            <div>
                <div class="input-group date" id="date-from">
                    <input id="startDate" class="form-control" type="date" formControlName="startDate"
                        [min]="MinStartDateValue!" max="{{MaxInitDateValue}}" (ngModelChange)="onChange($event,'startDate')" />
                </div>
            </div>
            <div class="show_filters_arrow_deco">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12H19" stroke="#333333" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 5L19 12L12 19" stroke="#333333" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <div>
                <div class="input-group date" id="date-to">
                    <input id="endDate" class="form-control" type="date" formControlName="endDate"
                        max="{{MaxEndDateValue}}" (ngModelChange)="onChange($event,'endDate')" />
                </div>
                <div *ngIf="dateRangeError" class="text-danger small mt-1">
                    {{ 'ANALYTICS.DATE_RANGE_MAX_4_MONTHS' | translate }}
                </div>
            </div>
            <div class='form-select-ng d-flex'>
                <app-basic-virtual-scroll *ngIf="configSvc.currentConfigValue.childEntities"
                    (callback)="callbackPartners($event)" [typeData]="typeData" [refresh]=""></app-basic-virtual-scroll>
            </div>
            <div class="show_filters_pb btn-light" (click)="toogleFilters()">
                <div class="show_filters_rot">{{ (showFilters ? 'DATATABLE.FILTERS.LESS' : 'DATATABLE.FILTERS.MORE') |
                    translate
                    }}</div>
                <div>
                    <div [ngClass]="{'caret-rotate':showFilters}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 2 24 24" fill="none">
                            <path d="M7 10L12.5 15.5L18 10" stroke="#333333" />
                        </svg>
                    </div>
                </div>
            </div>
            <div>
                <span *ngIf="filters_applyed" class="filters_applied"
                    title="{{'DATATABLE.FILTERS.APPLIED' | translate}}">!</span>
                <div class="apply_filters_pb btn btn-dark" [ngClass]="{'apply_filters_pb-disabled':!apply_filters_pb || dateRangeError}"
                    (click)="applyFilters()">
                    <div class="apply_filters_rot">{{ 'DATATABLE.FILTERS.APPLY' | translate }}</div>
                    <div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 2 24 24"
                                fill="none">
                                <path d="M7 10L12.5 15.5L18 10" stroke="#ffffff" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <div class="filters-noSql-search">
                <div class="input-group" id="search">
                    <span class="input-group-text bg-white border-r-0"><i class="bi bi-search"></i></span>
                    <input type="search" class="form-control" formControlName="search" [placeholder]="'DATATABLE.SEARCH' | translate"
                         (ngModelChange)="onChange($event,'search')"
                        (keyup.enter)="applyFilters()">
                </div>
            </div>
        </div>
        <div [hidden]="!showFilters">
            <div class='form-select-ng '>
                <ng-select [searchable]="false" formControlName="category" labelForId="yesno" [(ngModel)]="selectedCategory"
                    placeholder="{{'DATATABLE.FILTERS.CATEGORY' | translate}}" (ngModelChange)="onChange($event,'category')">
                    <ng-option *ngFor="let option of categories" [value]="option.id">{{option.name |
                        lowercase}}</ng-option>
                </ng-select>
            </div>

            <!-- <div class='form-select-ng '>
              <ng-select [searchable]="false" labelForId="yesno" [(ngModel)]="selectedTeam"
                [ngModelOptions]="{standalone: true}"
                placeholder="{{ 'DATATABLE.FILTERS.TEAM' | translate }}"
                (ngModelChange)="onChange($event,'team')">
                <ng-option [value]="null">{{ 'DATATABLE.FILTERS.ALLTEAMS' | translate }}</ng-option>
                <ng-option *ngFor="let option of teams" [value]="option.id">{{ option.name }}</ng-option>
              </ng-select>
            </div> -->

            <div *ngIf="this.user.role?.id === 1 || this.user.role?.id === 2" class="form-filters-check">
                <input class="form-check-input" type="checkbox" formControlName="withoutActivity"
                    (ngModelChange)="onChange($event,'withoutActivity')">
                <label class="form-check-label">
                    {{ 'Show only entities without activity' | translate }}
                </label>
            </div>
            <div class="clear_filters_pb btn btn-dark" [ngClass]="{'clear_filters_pb_disabled':!filters_applyed}">
                <div class="clear_filters_close">
                    <div class="clear_filters_close_icon"></div>
                </div>
                <div class="clear_filters_rot" (click)="cleanFilters()">{{ 'DATATABLE.FILTERS.CLEAR' | translate }}
                </div>
            </div>
        </div>
        <div>
            
        </div>
    </div>
</form>